module.exports = __webpack_public_path__ + "static/media/998172.bd0023ad.png";